module.exports = __webpack_public_path__ + "img/ac.a8a0c927.svg";